import { dimensions, SvgIconProps } from "./SvgIcon";

export const CopyIcon = (props: SvgIconProps) => {
  const { width, height } = dimensions(props);
  return (
    <svg
      style={{ display: "block", ...props.style }}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33301 9.9987C2.71175 9.9987 2.40112 9.9987 2.1561 9.8972C1.82939 9.76188 1.56983 9.50231 1.4345 9.17561C1.33301 8.93058 1.33301 8.61995 1.33301 7.9987V3.46536C1.33301 2.71863 1.33301 2.34526 1.47833 2.06004C1.60616 1.80916 1.81014 1.60519 2.06102 1.47736C2.34624 1.33203 2.7196 1.33203 3.46634 1.33203H7.99967C8.62093 1.33203 8.93156 1.33203 9.17659 1.43353C9.50329 1.56885 9.76286 1.82842 9.89818 2.15512C9.99967 2.40015 9.99967 2.71078 9.99967 3.33203M8.13301 14.6654H12.533C13.2797 14.6654 13.6531 14.6654 13.9383 14.52C14.1892 14.3922 14.3932 14.1882 14.521 13.9374C14.6663 13.6521 14.6663 13.2788 14.6663 12.532V8.13203C14.6663 7.38529 14.6663 7.01193 14.521 6.72671C14.3932 6.47583 14.1892 6.27185 13.9383 6.14402C13.6531 5.9987 13.2797 5.9987 12.533 5.9987H8.13301C7.38627 5.9987 7.0129 5.9987 6.72769 6.14402C6.4768 6.27185 6.27283 6.47583 6.145 6.72671C5.99967 7.01193 5.99967 7.38529 5.99967 8.13203V12.532C5.99967 13.2788 5.99967 13.6521 6.145 13.9374C6.27283 14.1882 6.4768 14.3922 6.72769 14.52C7.0129 14.6654 7.38627 14.6654 8.13301 14.6654Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
